var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-autocomplete',{attrs:{"value":_vm.value,"items":_vm.parameters,"disabled":_vm.disabled,"multiple":true,"chips":"","small-chips":"","deletable-chips":"","item-text":"name","item-value":"number","label":_vm.$trans('monitor.parameter')},on:{"change":_vm.emitInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }